<template>
	<div class="app-content bg-gray-100">
		<slot />
	</div>
</template>

<style lang="scss">
.app-content {
	overflow: auto;

	// Force the scrollbar on every page. Done to prevent layout flipping back-and-forth,
	// when changing between scrollable and unscrollable content. Only drawback is the
	// premanent scrollbar. Scrollbar-gutter might be an alternative.
	overflow-y: scroll;
	display: flex;
	flex-direction: column;
	align-content: flex-start;
	width: 100%;

	@media screen and (max-width: var(--mobile-size)) {
		overflow: unset;
		overflow-x: hidden;
	}

	.child-page {
		margin-left: var(--app-content-padding);
		margin-right: var(--app-content-padding);
	}
}
</style>
